import { getDisplayCostFromValue } from '../../containers/ticketSelection/utils/ticketPriceUtils';
import { CheckoutState } from '../../state';
import { getDisplayCostProps } from '../tickets/getDisplayCostProps';
import { getCalculatedShippingFees } from './getCalculatedShippingFees';
import { getOrderCosts } from './getOrderCosts';

/**
 * If order costs are present, return the total cost display value
 * based on the values, as they are calculated in the backend by order service.
 * Fall back to calculating in the FE using based on selected tickets.
 *
 * @param {object} state The entire redux state
 * @was `utils/forms.js:getTotalCostsDisplay`
 */
// TODO: Disambiguate from `containers/ticketSelection/utils.js:getTotalDisplayCost
// it appears these functions do pretty much the same thing?
export const getTotalCostDisplay = (state: CheckoutState) => {
    const orderCosts = getOrderCosts(state, true);

    // TODO: Remove this update after removing shippingRates endpoints
    if (orderCosts) {
        const shippingFee = getCalculatedShippingFees(state);
        return getDisplayCostFromValue(
            orderCosts.gross.value + shippingFee,
            state.event.currency,
            state.app.currencyFormat,
        );
    }

    return getDisplayCostProps(state).totalCostDisplay;
};
